import { QueryClient } from "@tanstack/react-query";
import { redirect } from "react-router-dom";
import { getCabinetQueryOptions } from "@/entities/cabinet/api/getCabinetQueryOptions";
import { getProfileQueryOptions } from "@/entities/profile/api/getProfileQueryOptions";

import { CabinetStatuses } from "@/pages/Cabinet/types";

export const cabinetLoader = (queryClient: QueryClient) => async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return redirect("/auth", { status: 301 });
  }

  const [cabinetResponse, profileResponse] = await Promise.all([
    queryClient.fetchQuery(getCabinetQueryOptions(token)),
    queryClient.fetchQuery(getProfileQueryOptions(token)),
  ]);

  const component = cabinetResponse?.component;
  const isSuccess = cabinetResponse.success;

  const isRegistrationUpdate =
    component === CabinetStatuses.registration_update;
  const isApplication = component === CabinetStatuses.application;
  const isInfo = component === CabinetStatuses.info;
  const isSignAgreement = component === CabinetStatuses.sign;
  const isDeal = component === CabinetStatuses.deal;
  const isProlongation = component === CabinetStatuses.prolongation;
  const isRepeat = component === CabinetStatuses.repeat;
  const isBlocking = component === CabinetStatuses.blocking;

  const { profile } = profileResponse;
  const isProfileFilled =
    typeof profile?.iban === "string" &&
    typeof profile?.name === "string" &&
    typeof profile?.surname === "string" &&
    typeof profile?.work_company === "string" &&
    typeof profile?.family_status === "string" &&
    typeof profile?.children_count === "number";

  const isAuthRedirect =
    !isRegistrationUpdate &&
    !isApplication &&
    !isInfo &&
    !isSignAgreement &&
    !isDeal &&
    !isProlongation &&
    !isRepeat &&
    !isBlocking;

  if ((isAuthRedirect && isSuccess) || !isProfileFilled) {
    return redirect("/auth", { status: 301 });
  }

  return cabinetResponse;
};
